export interface BaseRequest {
  version?: string;
  lang?: string;
}

const baseReq: BaseRequest = {
  version: "2",
  lang: "zh-CN"
};

export interface PageQuery {
  pageNum?: number;
  pageSize?: number;
}

export interface ResponsePage<T> {
  success: boolean,
  rsCode: string,
  rsMessages: string,
  pageNum: number;
  pageSize: number;
  pageTotal: number;
  rsData: T[];
}

export enum DeleteStatus {
  DELETED = "1",
  DEFAULT = "0"
}

export { baseReq };
